import React from 'react';
import Loadable from 'react-loadable';
import {
  BrowserRouter as Router,
  Route,
} from 'react-router-dom';
import ResetPasswordConnectErrorBoundary from '../components/ResetPasswordConnectErrorBoundary/ResetPasswordConnectErrorBoundary';

// Set a `basename` to be used by the Router/
const basename = process.env.NODE_ENV === 'production' ? '/login' : '/';

const LoadingComponent = () => null;

const LoginForm = Loadable({
    loader: () => import('../components/LoginForm/LoginForm'),
    loading: LoadingComponent
});

const Logout = Loadable({
    loader: () => import('./Logout/Logout'),
    loading: LoadingComponent
});

const ResetPasswordConnector = Loadable({
  loader: () => import('../components/ResetPasswordConnector/ResetPasswordConnector'),
  loading: LoadingComponent
});

const ForgotPasswordForm = Loadable({
    loader: () => import('../components/ForgotPasswordForm/ForgotPasswordForm'),
    loading: LoadingComponent
});

const ErrorBar = Loadable({
  loader: () => import('./ErrorBar/ErrorBar'),
  loading() {
    return null
  },
});

const RouteWithErrorBar = ({component: Component, ...props}) => {
  return (
    <Route
      {...props}
      render={(props) => <Component {...props} errorBar={ErrorBar} />}
    />);
}

const ResetPasswordRouteWithErrorBar = ({component: Component, ...props}) => {
  return (
    <Route
      {...props}
      render={(props) => (
        <ResetPasswordConnectErrorBoundary>
          <Component {...props} errorBar={ErrorBar} />
        </ResetPasswordConnectErrorBoundary>
      )}
    />);
}

const Routes = () => (
  <Router basename={basename}>
    <React.Fragment>
      <RouteWithErrorBar exact path="/" component={LoginForm}/>

      <RouteWithErrorBar exact path="/logout" component={Logout}/>

      <RouteWithErrorBar exact path="/forgot-password" component={ForgotPasswordForm}/>

      <ResetPasswordRouteWithErrorBar exact path="/reset-password" component={ResetPasswordConnector} />

    </React.Fragment>
  </Router>
);

const Main = () => (
  <Routes />
);

export default Main;



// WEBPACK FOOTER //
// ./src/containers/Main.js